import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { osFetch, setActiveOrg } from "./api";

const OSContext = createContext(null);
export const useOS = () => useContext(OSContext);

export function OSProvider({ children }) {
  const [ctx, setCtx] = useState(undefined); // undefined=loading, null=error/guest, object=ready
  const [orgs, setOrgs] = useState([]);
  const [orgId, setOrgId] = useState(localStorage.getItem("arca_os_org") || null);
  const [attention, setAttention] = useState({ total_open: 0, by_entity_type: {}, by_category: {} });

  const reloadAttention = useCallback(async () => {
    try { setAttention(await osFetch("/attention/counts")); } catch { /* non-blocking */ }
  }, []);

  const load = useCallback(async () => {
    try {
      const orgList = await osFetch("/orgs");
      setOrgs(orgList);
      const active = orgId && orgList.find((o) => o.id === orgId) ? orgId : (orgList[0]?.id || null);
      if (active) { setActiveOrg(active); setOrgId(active); localStorage.setItem("arca_os_org", active); }
      const c = await osFetch("/context");
      setCtx(c);
      reloadAttention();
    } catch (e) {
      setCtx(null);
    }
  }, [orgId, reloadAttention]);

  useEffect(() => { load(); }, []);

  const switchOrg = useCallback(async (id) => {
    setActiveOrg(id); setOrgId(id); localStorage.setItem("arca_os_org", id);
    const c = await osFetch("/context");
    setCtx(c);
    reloadAttention();
  }, [reloadAttention]);

  const can = useCallback((perm) => !!ctx?.permissions?.includes(perm), [ctx]);

  return (
    <OSContext.Provider value={{ ctx, orgs, orgId, switchOrg, can, reload: load, attention, reloadAttention }}>
      {children}
    </OSContext.Provider>
  );
}
